export default [
  {
    path: 'jogadores',
    name: 'jogadores.group',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'Jogadores',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Jogadores' }
      ]
    }
  },
]